import React, { type FC } from 'react';
import type { List } from 'immutable';

import { SLOT_FAMILY, SLOT_FAMILY_CORRECT_SCORE_SINGLE_BET } from 'app/constants/matchCenterStakes';
import type { RecordOfStakeEntity } from 'app/lib/betting/betting-entities';

import CorrectScore from './CorrectScore';
import DefaultSlotContentComponent from './DefaultSlotContentComponent';

type SlotContentComponentProps = {
  stakes: List<RecordOfStakeEntity>;
  slotFamily?: SLOT_FAMILY;
};

export const SlotContentComponent: FC<SlotContentComponentProps> = ({
  stakes,
  slotFamily,
}) => {
  switch (slotFamily) {
    case SLOT_FAMILY_CORRECT_SCORE_SINGLE_BET:
      return (
        <CorrectScore stakes={stakes} />
      );
    default:
      return (
        <DefaultSlotContentComponent stakes={stakes} />
      );
  }
};
